import { Divider, Tab, Theme, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CategoryDisplayName } from '@oxappsec/ox-consolidated-categories';
import { FC } from 'react';
import {
  AppPages,
  navigate,
  navigateToIssues,
} from '../../../common/routing/app-navigator';
import useOxTabs from '../../../elements/OxTabs/hooks/useOxTabs';
import OxTabs from '../../../elements/OxTabs/OxTabs';
import SlidingPanel from '../../../elements/SlidingPanel/SlidingPanel';
import TopIssuesTable from '../../../issues/top-issues/components/TopIssuesTable';
import { Issue } from '../../../issues/common/types/issues-types';
import { FaExternalLinkAlt } from 'react-icons/fa';

const DashboardSecToolsIssues: FC<
  React.PropsWithChildren<DashboardSecToolsIssuesProps>
> = ({ tabLabel, topIssues, title, category }) => {
  const { classes } = useStyles();
  const { handleTabChange, tabIndex } = useOxTabs();

  const handleClick = () => {
    if (category) {
      navigateToIssues({
        categories: [category as CategoryDisplayName],
      });
    } else {
      navigate(AppPages.Issues);
    }
  };

  return (
    <>
      <OxTabs selectedTab={tabIndex} onChange={handleTabChange}>
        <Tab
          label={
            <Tooltip
              arrow
              title={
                title ||
                'These are the most important issues across all categories to address'
              }>
              <div>{tabLabel}</div>
            </Tooltip>
          }
          icon={
            <FaExternalLinkAlt
              style={{ color: '#585cfc', height: '8px', width: '8px' }}
            />
          }
          iconPosition='end'
          onClick={handleClick}
          sx={{ maxWidth: 500, height: '10px', textTransform: 'none' }}
        />
      </OxTabs>
      <Divider />
      <div>
        <SlidingPanel activeIndex={tabIndex} index={0}>
          {topIssues && (
            <TopIssuesTable
              tableClassName={classes.issuesTable}
              issues={topIssues}
              category={category}
            />
          )}
        </SlidingPanel>
      </div>
    </>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  issuesTable: {
    tableLayout: 'fixed',
    '& > thead > tr > th': {
      lineHeight: '1.2',
    },
  },
}));

export interface DashboardSecToolsIssuesProps {
  tabLabel: string;
  topIssues?: Issue[];
  title?: string;
  category: string;
}

export default DashboardSecToolsIssues;
